import React from 'react'
import { faUpload } from '@fortawesome/free-solid-svg-icons'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  PixelIcon,
  PixelPageContainer,
  PixelTable,
  Section,
} from 'pixel-base'
import queryString from 'query-string'
import {
  getGeneralCourierList,
  getMonthlyPayments,
} from 'utils/api-routes.util'
import { SectionContent } from 'app/common/styles/section'

import UploadPaymentInvoice from '../UploadPaymentInvoice'

const columns = [
  {
    dataKey: 'tracking_id',
    name: 'CN #',
    sortable: true,
    selector: (row) => row.tracking_id || '--',
  },
  {
    dataKey: 'ref_no',
    name: 'Ref #',
    sortable: true,
    selector: (row) => row.ref_no || '--',
  },
  {
    dataKey: 'booking_date',
    name: 'Booking Date',
    sortable: true,
    selector: (row) => row.booking_date || '--',
  },
  {
    dataKey: 'total',
    name: 'Total Amount',
    sortable: true,
    selector: (row) => row.total || '--',
  },
  {
    dataKey: 'cod_amount_booked',
    name: 'COD Amount',
    sortable: true,
    selector: (row) => row.cod_amount_booked || '--',
  },
  {
    dataKey: 'advance_payment',
    name: 'Advance Payment',
    sortable: true,
    selector: (row) => row.advance_payment || '--',
  },
  {
    dataKey: 'shipping_fee',
    name: 'Shipping Fee',
    sortable: true,
    selector: (row) => row.shipping_fee || '--',
  },
  {
    dataKey: 'courier_name',
    name: 'Courier',
    sortable: true,
    selector: (row) => row.courier_name || '--',
  },
  {
    dataKey: 'status',
    name: 'Status',
    sortable: true,
    selector: (row) => row.status || '--',
  },
  {
    dataKey: 'delivery_status',
    name: 'Payment Status',
    sortable: true,
    selector: (row) => row.delivery_status || '--',
  },
]

const breadcrumbs = [
  {
    name: 'Monthly Payments',
    active: false,
    link: '/payments/payments-month-wise',
  },
  {
    name: 'Monthly Payments Details',
    active: true,
  },
]

const MonthWiseDetail = () => {
  const [tableLoading, setTableLoading] = React.useState(true)
  const [monthlyPayments, setMonthlyPayments] = React.useState([])
  const [filters, setFilters] = React.useState<any>({
    month: '',
    courier: null,
    rider_id: null,
  })
  const [courierList, setCourierList] = React.useState([])

  const [showModal, setShowModal] = React.useState(false)
  React.useEffect(() => {
    const params = queryString.parse(location.search)
    setFilters({
      ...filters,
      month: params?.month,
      courier: params?.courier || null,
    })
    getAllcourierList()
  }, [])
  const getAllcourierList = () => {
    getGeneralCourierList().subscribe((res: any) => {
      setCourierList(res.response.data)
    })
  }
  React.useEffect(() => {
    if (filters.month) getAllMonthlyPayments()
  }, [filters])

  const getAllMonthlyPayments = () => {
    setTableLoading(true)
    getMonthlyPayments(filters).subscribe((res: any) => {
      setMonthlyPayments(res.response.data)
      setTableLoading(false)
    })
  }

  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{ fontSize: '16px', padding: '8px 0px' }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>
      <DcFlexBox
        padding="0px 20px 5px 20px"
        justifyContent="flex-end"
        height="auto"
      >
        <DcButton size="sm" onClick={() => setShowModal(true)}>
          <PixelIcon icon={faUpload} color="#fff" /> Upload Invoice
        </DcButton>
      </DcFlexBox>
      <PixelPageContainer padding="0 ">
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={monthlyPayments}
              isSearchable={false}
              progressPending={tableLoading}
              fixedHeader={true}
              fixedHeaderScrollHeight="calc(100vh - 211px)"
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      {showModal && (
        <UploadPaymentInvoice
          show={showModal}
          courierList={courierList}
          handleClose={() => {
            setShowModal(false)
          }}
        />
      )}
    </>
  )
}

export default MonthWiseDetail
